import React from 'react';
import { DatePicker, Tooltip } from 'antd';
import moment from 'moment';
import { IDate } from 'src/common/IDate';


interface IProps {
	onChange: any;
	date: IDate|null;
	onDateChange: any;
	accessor: string;
}

export const DateFilter = ({ onChange, date, onDateChange, accessor }: IProps) => {
	return (
		<div className="rt-datepicker-wrapper">
			<div className="rt-datepicker-value">
				{date === null && <span className="rt-datepicker-placeholder btn btn-link">All</span>}
				{date !== null && (
					<React.Fragment>
						<span className="rt-datepicker-value-start d-block text-primary">
							{date!.start.format('MMM DD, YYYY')} ~
						</span>
						<span className="rt-datepicker-value-end d-block text-primary">
							{date!.end.format('MMM DD, YYYY')}
						</span>
					</React.Fragment>
				)}
			</div>
			<DatePicker.RangePicker
				onChange={onDateChange(accessor, onChange)}
				style={{ width: '100%', cursor: 'pointer' }}
				format="MMM DD, YYYY"
			/>
		</div>
	);
};

export const dateFilterMethod = (accessor: string) => (filter: any, rowData: any) => {
	if (!rowData[accessor]) {
		return false;
	}
	const date = moment(rowData[accessor]);
	const [startDate, endDate] = filter.value;
	return (moment(date).utc().startOf('day').isSameOrAfter(moment(startDate).utc().startOf('day')) &&
		moment(date).utc().startOf('day').isSameOrBefore(moment(endDate).utc().startOf('day')));
};

export const setDateColumnCellValue = (row: any) => row.value ? <Tooltip title={moment(row.value).format('MMM DD, YYYY')}>{moment(row.value).format('MMM DD, YYYY')}</Tooltip> : "-";
